import React from 'react'
import Layout from '../../components/layout/layout.component'

export default function PublicationPageDetail() {
  return <Layout>PublicationPageDetail</Layout>
}
